import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TrainingDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type TrainingDeleteMutation = { __typename?: 'Mutation', trainingDelete: { __typename?: 'TrainingPayload', recordId: string, record: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } }, errors?: Array<{ __typename?: 'TrainingDoesNotExistsProblem', message: string } | { __typename?: 'TrainingExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'TrainingSaveProblem', message: string } | { __typename?: 'TrainingUpdateProblem', message: string }> | null } };

export type TrainingPublishUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type TrainingPublishUpdateMutation = { __typename?: 'Mutation', trainingPublishUpdate: { __typename?: 'TrainingPayload', recordId: string, record: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } }, errors?: Array<{ __typename?: 'TrainingDoesNotExistsProblem', message: string } | { __typename?: 'TrainingExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'TrainingSaveProblem', message: string } | { __typename?: 'TrainingUpdateProblem', message: string }> | null } };

export type TrainingSaveMutationVariables = Types.Exact<{
  trainingInput: Types.TrainingInput;
}>;


export type TrainingSaveMutation = { __typename?: 'Mutation', trainingSave: { __typename?: 'TrainingPayload', recordId: string, record: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } }, errors?: Array<{ __typename?: 'TrainingDoesNotExistsProblem', message: string } | { __typename?: 'TrainingExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'TrainingSaveProblem', message: string } | { __typename?: 'TrainingUpdateProblem', message: string }> | null } };

export type TrainingUpdateMutationVariables = Types.Exact<{
  trainingInput: Types.TrainingInputWithId;
}>;


export type TrainingUpdateMutation = { __typename?: 'Mutation', trainingUpdate: { __typename?: 'TrainingPayload', recordId: string, record: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } }, errors?: Array<{ __typename?: 'TrainingDoesNotExistsProblem', message: string } | { __typename?: 'TrainingExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'TrainingSaveProblem', message: string } | { __typename?: 'TrainingUpdateProblem', message: string }> | null } };

export type TrainingQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type TrainingQuery = { __typename?: 'Query', training?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null };

export type TrainingAllQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TrainingAllQuery = { __typename?: 'Query', trainingAll?: Array<{ __typename?: 'TrainingDto', value: string, label: string }> | null };

export type TrainingsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['ID']>;
  before?: Types.InputMaybe<Types.Scalars['ID']>;
  filter?: Types.InputMaybe<Types.TrainingFilter>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type TrainingsQuery = { __typename?: 'Query', trainings?: { __typename?: 'TrainingConnection', edges: Array<{ __typename?: 'TrainingEdge', cursor: string, node?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null }>, pageInfo?: { __typename?: 'PageInfo', endCursor: string, hasNextPage?: boolean | null, startCursor: string } | null } | null };

export type TrainingsByDayQueryVariables = Types.Exact<{
  date: Types.Scalars['Date'];
}>;


export type TrainingsByDayQuery = { __typename?: 'Query', trainingsByDay?: Array<{ __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } }> | null };

export type TrainingsByMonthQueryVariables = Types.Exact<{
  date: Types.Scalars['Date'];
}>;


export type TrainingsByMonthQuery = { __typename?: 'Query', trainingsByMonth?: Array<{ __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number }> | null };

export type TrainingsByDayAndUserQueryVariables = Types.Exact<{
  date: Types.Scalars['Date'];
}>;


export type TrainingsByDayAndUserQuery = { __typename?: 'Query', trainingsByDayAndUser?: Array<{ __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } }> | null };

export type TrainingsGenerateMutationVariables = Types.Exact<{
  startDate: Types.Scalars['Date'];
  finishDate: Types.Scalars['Date'];
}>;


export type TrainingsGenerateMutation = { __typename?: 'Mutation', trainingsGenerate?: Array<{ __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, rentPaymentSum: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } }> | null };

export type UpdateTrainingsAndCoachesMutationVariables = Types.Exact<{
  input: Types.TrainingCoachesAndVisitsInput;
}>;


export type UpdateTrainingsAndCoachesMutation = { __typename?: 'Mutation', updateTrainingCoachesAndVisits: { __typename?: 'TrainingPayload', recordId: string, record: { __typename?: 'Training', id: string, time?: any | null, visits: number, rentPaymentSum: number, headCoach?: { __typename?: 'Staff', name: string } | null, coaches?: Array<{ __typename?: 'Staff', name: string }> | null, team: { __typename?: 'Team', name: string }, stadium?: { __typename?: 'Stadium', name: string } | null } } };


export const TrainingDeleteDocument = gql`
    mutation trainingDelete($id: ID!) {
  trainingDelete(id: $id) {
    record {
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      published
      stadium {
        id
        latitude
        longitude
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
      }
      stadiumId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      time
      visits
      rentPaymentSum
    }
    recordId
    errors {
      ... on TrainingDoesNotExistsProblem {
        message
      }
      ... on TrainingExistInOtherComponentsProblem {
        component
        message
      }
      ... on TrainingSaveProblem {
        message
      }
      ... on TrainingUpdateProblem {
        message
      }
    }
  }
}
    `;
export type TrainingDeleteMutationFn = Apollo.MutationFunction<TrainingDeleteMutation, TrainingDeleteMutationVariables>;

/**
 * __useTrainingDeleteMutation__
 *
 * To run a mutation, you first call `useTrainingDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainingDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainingDeleteMutation, { data, loading, error }] = useTrainingDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainingDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TrainingDeleteMutation, TrainingDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainingDeleteMutation, TrainingDeleteMutationVariables>(TrainingDeleteDocument, options);
      }
export type TrainingDeleteMutationHookResult = ReturnType<typeof useTrainingDeleteMutation>;
export type TrainingDeleteMutationResult = Apollo.MutationResult<TrainingDeleteMutation>;
export type TrainingDeleteMutationOptions = Apollo.BaseMutationOptions<TrainingDeleteMutation, TrainingDeleteMutationVariables>;
export const TrainingPublishUpdateDocument = gql`
    mutation trainingPublishUpdate($id: ID!) {
  trainingPublishUpdate(id: $id) {
    record {
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      published
      stadium {
        id
        latitude
        longitude
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
      }
      stadiumId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      time
      visits
      rentPaymentSum
    }
    recordId
    errors {
      ... on TrainingDoesNotExistsProblem {
        message
      }
      ... on TrainingExistInOtherComponentsProblem {
        component
        message
      }
      ... on TrainingSaveProblem {
        message
      }
      ... on TrainingUpdateProblem {
        message
      }
    }
  }
}
    `;
export type TrainingPublishUpdateMutationFn = Apollo.MutationFunction<TrainingPublishUpdateMutation, TrainingPublishUpdateMutationVariables>;

/**
 * __useTrainingPublishUpdateMutation__
 *
 * To run a mutation, you first call `useTrainingPublishUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainingPublishUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainingPublishUpdateMutation, { data, loading, error }] = useTrainingPublishUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainingPublishUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TrainingPublishUpdateMutation, TrainingPublishUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainingPublishUpdateMutation, TrainingPublishUpdateMutationVariables>(TrainingPublishUpdateDocument, options);
      }
export type TrainingPublishUpdateMutationHookResult = ReturnType<typeof useTrainingPublishUpdateMutation>;
export type TrainingPublishUpdateMutationResult = Apollo.MutationResult<TrainingPublishUpdateMutation>;
export type TrainingPublishUpdateMutationOptions = Apollo.BaseMutationOptions<TrainingPublishUpdateMutation, TrainingPublishUpdateMutationVariables>;
export const TrainingSaveDocument = gql`
    mutation trainingSave($trainingInput: TrainingInput!) {
  trainingSave(trainingInput: $trainingInput) {
    record {
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      published
      stadium {
        id
        latitude
        longitude
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
      }
      stadiumId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      time
      visits
      rentPaymentSum
    }
    recordId
    errors {
      ... on TrainingDoesNotExistsProblem {
        message
      }
      ... on TrainingExistInOtherComponentsProblem {
        component
        message
      }
      ... on TrainingSaveProblem {
        message
      }
      ... on TrainingUpdateProblem {
        message
      }
    }
  }
}
    `;
export type TrainingSaveMutationFn = Apollo.MutationFunction<TrainingSaveMutation, TrainingSaveMutationVariables>;

/**
 * __useTrainingSaveMutation__
 *
 * To run a mutation, you first call `useTrainingSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainingSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainingSaveMutation, { data, loading, error }] = useTrainingSaveMutation({
 *   variables: {
 *      trainingInput: // value for 'trainingInput'
 *   },
 * });
 */
export function useTrainingSaveMutation(baseOptions?: Apollo.MutationHookOptions<TrainingSaveMutation, TrainingSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainingSaveMutation, TrainingSaveMutationVariables>(TrainingSaveDocument, options);
      }
export type TrainingSaveMutationHookResult = ReturnType<typeof useTrainingSaveMutation>;
export type TrainingSaveMutationResult = Apollo.MutationResult<TrainingSaveMutation>;
export type TrainingSaveMutationOptions = Apollo.BaseMutationOptions<TrainingSaveMutation, TrainingSaveMutationVariables>;
export const TrainingUpdateDocument = gql`
    mutation trainingUpdate($trainingInput: TrainingInputWithId!) {
  trainingUpdate(trainingInput: $trainingInput) {
    record {
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      published
      stadium {
        id
        latitude
        longitude
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
      }
      stadiumId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      time
      visits
      rentPaymentSum
    }
    recordId
    errors {
      ... on TrainingDoesNotExistsProblem {
        message
      }
      ... on TrainingExistInOtherComponentsProblem {
        component
        message
      }
      ... on TrainingSaveProblem {
        message
      }
      ... on TrainingUpdateProblem {
        message
      }
    }
  }
}
    `;
export type TrainingUpdateMutationFn = Apollo.MutationFunction<TrainingUpdateMutation, TrainingUpdateMutationVariables>;

/**
 * __useTrainingUpdateMutation__
 *
 * To run a mutation, you first call `useTrainingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainingUpdateMutation, { data, loading, error }] = useTrainingUpdateMutation({
 *   variables: {
 *      trainingInput: // value for 'trainingInput'
 *   },
 * });
 */
export function useTrainingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TrainingUpdateMutation, TrainingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainingUpdateMutation, TrainingUpdateMutationVariables>(TrainingUpdateDocument, options);
      }
export type TrainingUpdateMutationHookResult = ReturnType<typeof useTrainingUpdateMutation>;
export type TrainingUpdateMutationResult = Apollo.MutationResult<TrainingUpdateMutation>;
export type TrainingUpdateMutationOptions = Apollo.BaseMutationOptions<TrainingUpdateMutation, TrainingUpdateMutationVariables>;
export const TrainingDocument = gql`
    query training($id: ID!) {
  training(id: $id) {
    coachIds
    coaches {
      birthday
      department
      description
      fileName
      id
      name
      orderNumber
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      work
    }
    headCoach {
      birthday
      department
      description
      fileName
      id
      name
      orderNumber
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      work
    }
    headCoachId
    id
    published
    stadium {
      id
      latitude
      longitude
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
    }
    stadiumId
    team {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    teamId
    time
    visits
    rentPaymentSum
  }
}
    `;

/**
 * __useTrainingQuery__
 *
 * To run a query within a React component, call `useTrainingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainingQuery(baseOptions: Apollo.QueryHookOptions<TrainingQuery, TrainingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingQuery, TrainingQueryVariables>(TrainingDocument, options);
      }
export function useTrainingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingQuery, TrainingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingQuery, TrainingQueryVariables>(TrainingDocument, options);
        }
export type TrainingQueryHookResult = ReturnType<typeof useTrainingQuery>;
export type TrainingLazyQueryHookResult = ReturnType<typeof useTrainingLazyQuery>;
export type TrainingQueryResult = Apollo.QueryResult<TrainingQuery, TrainingQueryVariables>;
export function refetchTrainingQuery(variables: TrainingQueryVariables) {
      return { query: TrainingDocument, variables: variables }
    }
export const TrainingAllDocument = gql`
    query trainingAll {
  trainingAll {
    value
    label
  }
}
    `;

/**
 * __useTrainingAllQuery__
 *
 * To run a query within a React component, call `useTrainingAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrainingAllQuery(baseOptions?: Apollo.QueryHookOptions<TrainingAllQuery, TrainingAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingAllQuery, TrainingAllQueryVariables>(TrainingAllDocument, options);
      }
export function useTrainingAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingAllQuery, TrainingAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingAllQuery, TrainingAllQueryVariables>(TrainingAllDocument, options);
        }
export type TrainingAllQueryHookResult = ReturnType<typeof useTrainingAllQuery>;
export type TrainingAllLazyQueryHookResult = ReturnType<typeof useTrainingAllLazyQuery>;
export type TrainingAllQueryResult = Apollo.QueryResult<TrainingAllQuery, TrainingAllQueryVariables>;
export function refetchTrainingAllQuery(variables?: TrainingAllQueryVariables) {
      return { query: TrainingAllDocument, variables: variables }
    }
export const TrainingsDocument = gql`
    query trainings($after: ID, $before: ID, $filter: TrainingFilter, $first: Int, $last: Int) {
  trainings(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
        rentPaymentSum
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      startCursor
    }
  }
}
    `;

/**
 * __useTrainingsQuery__
 *
 * To run a query within a React component, call `useTrainingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useTrainingsQuery(baseOptions?: Apollo.QueryHookOptions<TrainingsQuery, TrainingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingsQuery, TrainingsQueryVariables>(TrainingsDocument, options);
      }
export function useTrainingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingsQuery, TrainingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingsQuery, TrainingsQueryVariables>(TrainingsDocument, options);
        }
export type TrainingsQueryHookResult = ReturnType<typeof useTrainingsQuery>;
export type TrainingsLazyQueryHookResult = ReturnType<typeof useTrainingsLazyQuery>;
export type TrainingsQueryResult = Apollo.QueryResult<TrainingsQuery, TrainingsQueryVariables>;
export function refetchTrainingsQuery(variables?: TrainingsQueryVariables) {
      return { query: TrainingsDocument, variables: variables }
    }
export const TrainingsByDayDocument = gql`
    query trainingsByDay($date: Date!) {
  trainingsByDay(date: $date) {
    coachIds
    coaches {
      birthday
      department
      description
      fileName
      id
      name
      orderNumber
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      work
    }
    headCoach {
      birthday
      department
      description
      fileName
      id
      name
      orderNumber
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      work
    }
    headCoachId
    id
    published
    stadium {
      id
      latitude
      longitude
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
    }
    stadiumId
    team {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    teamId
    time
    visits
    rentPaymentSum
  }
}
    `;

/**
 * __useTrainingsByDayQuery__
 *
 * To run a query within a React component, call `useTrainingsByDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingsByDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingsByDayQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTrainingsByDayQuery(baseOptions: Apollo.QueryHookOptions<TrainingsByDayQuery, TrainingsByDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingsByDayQuery, TrainingsByDayQueryVariables>(TrainingsByDayDocument, options);
      }
export function useTrainingsByDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingsByDayQuery, TrainingsByDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingsByDayQuery, TrainingsByDayQueryVariables>(TrainingsByDayDocument, options);
        }
export type TrainingsByDayQueryHookResult = ReturnType<typeof useTrainingsByDayQuery>;
export type TrainingsByDayLazyQueryHookResult = ReturnType<typeof useTrainingsByDayLazyQuery>;
export type TrainingsByDayQueryResult = Apollo.QueryResult<TrainingsByDayQuery, TrainingsByDayQueryVariables>;
export function refetchTrainingsByDayQuery(variables: TrainingsByDayQueryVariables) {
      return { query: TrainingsByDayDocument, variables: variables }
    }
export const TrainingsByMonthDocument = gql`
    query trainingsByMonth($date: Date!) {
  trainingsByMonth(date: $date) {
    coachIds
    headCoachId
    id
    published
    stadiumId
    teamId
    time
    visits
    rentPaymentSum
  }
}
    `;

/**
 * __useTrainingsByMonthQuery__
 *
 * To run a query within a React component, call `useTrainingsByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingsByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingsByMonthQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTrainingsByMonthQuery(baseOptions: Apollo.QueryHookOptions<TrainingsByMonthQuery, TrainingsByMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingsByMonthQuery, TrainingsByMonthQueryVariables>(TrainingsByMonthDocument, options);
      }
export function useTrainingsByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingsByMonthQuery, TrainingsByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingsByMonthQuery, TrainingsByMonthQueryVariables>(TrainingsByMonthDocument, options);
        }
export type TrainingsByMonthQueryHookResult = ReturnType<typeof useTrainingsByMonthQuery>;
export type TrainingsByMonthLazyQueryHookResult = ReturnType<typeof useTrainingsByMonthLazyQuery>;
export type TrainingsByMonthQueryResult = Apollo.QueryResult<TrainingsByMonthQuery, TrainingsByMonthQueryVariables>;
export function refetchTrainingsByMonthQuery(variables: TrainingsByMonthQueryVariables) {
      return { query: TrainingsByMonthDocument, variables: variables }
    }
export const TrainingsByDayAndUserDocument = gql`
    query trainingsByDayAndUser($date: Date!) {
  trainingsByDayAndUser(date: $date) {
    coachIds
    coaches {
      birthday
      department
      description
      fileName
      id
      name
      orderNumber
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      work
    }
    headCoach {
      birthday
      department
      description
      fileName
      id
      name
      orderNumber
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      work
    }
    headCoachId
    id
    published
    stadium {
      id
      latitude
      longitude
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
    }
    stadiumId
    team {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    teamId
    time
    visits
    rentPaymentSum
  }
}
    `;

/**
 * __useTrainingsByDayAndUserQuery__
 *
 * To run a query within a React component, call `useTrainingsByDayAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingsByDayAndUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingsByDayAndUserQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTrainingsByDayAndUserQuery(baseOptions: Apollo.QueryHookOptions<TrainingsByDayAndUserQuery, TrainingsByDayAndUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingsByDayAndUserQuery, TrainingsByDayAndUserQueryVariables>(TrainingsByDayAndUserDocument, options);
      }
export function useTrainingsByDayAndUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingsByDayAndUserQuery, TrainingsByDayAndUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingsByDayAndUserQuery, TrainingsByDayAndUserQueryVariables>(TrainingsByDayAndUserDocument, options);
        }
export type TrainingsByDayAndUserQueryHookResult = ReturnType<typeof useTrainingsByDayAndUserQuery>;
export type TrainingsByDayAndUserLazyQueryHookResult = ReturnType<typeof useTrainingsByDayAndUserLazyQuery>;
export type TrainingsByDayAndUserQueryResult = Apollo.QueryResult<TrainingsByDayAndUserQuery, TrainingsByDayAndUserQueryVariables>;
export function refetchTrainingsByDayAndUserQuery(variables: TrainingsByDayAndUserQueryVariables) {
      return { query: TrainingsByDayAndUserDocument, variables: variables }
    }
export const TrainingsGenerateDocument = gql`
    mutation trainingsGenerate($startDate: Date!, $finishDate: Date!) {
  trainingsGenerate(startDate: $startDate, finishDate: $finishDate) {
    coachIds
    coaches {
      birthday
      department
      description
      fileName
      id
      name
      orderNumber
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      work
    }
    headCoach {
      birthday
      department
      description
      fileName
      id
      name
      orderNumber
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      work
    }
    headCoachId
    id
    published
    stadium {
      id
      latitude
      longitude
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
    }
    stadiumId
    team {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    teamId
    time
    visits
    rentPaymentSum
  }
}
    `;
export type TrainingsGenerateMutationFn = Apollo.MutationFunction<TrainingsGenerateMutation, TrainingsGenerateMutationVariables>;

/**
 * __useTrainingsGenerateMutation__
 *
 * To run a mutation, you first call `useTrainingsGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainingsGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainingsGenerateMutation, { data, loading, error }] = useTrainingsGenerateMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      finishDate: // value for 'finishDate'
 *   },
 * });
 */
export function useTrainingsGenerateMutation(baseOptions?: Apollo.MutationHookOptions<TrainingsGenerateMutation, TrainingsGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrainingsGenerateMutation, TrainingsGenerateMutationVariables>(TrainingsGenerateDocument, options);
      }
export type TrainingsGenerateMutationHookResult = ReturnType<typeof useTrainingsGenerateMutation>;
export type TrainingsGenerateMutationResult = Apollo.MutationResult<TrainingsGenerateMutation>;
export type TrainingsGenerateMutationOptions = Apollo.BaseMutationOptions<TrainingsGenerateMutation, TrainingsGenerateMutationVariables>;
export const UpdateTrainingsAndCoachesDocument = gql`
    mutation updateTrainingsAndCoaches($input: TrainingCoachesAndVisitsInput!) {
  updateTrainingCoachesAndVisits(input: $input) {
    record {
      id
      time
      headCoach {
        name
      }
      coaches {
        name
      }
      team {
        name
      }
      visits
      rentPaymentSum
      stadium {
        name
      }
    }
    recordId
  }
}
    `;
export type UpdateTrainingsAndCoachesMutationFn = Apollo.MutationFunction<UpdateTrainingsAndCoachesMutation, UpdateTrainingsAndCoachesMutationVariables>;

/**
 * __useUpdateTrainingsAndCoachesMutation__
 *
 * To run a mutation, you first call `useUpdateTrainingsAndCoachesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainingsAndCoachesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainingsAndCoachesMutation, { data, loading, error }] = useUpdateTrainingsAndCoachesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainingsAndCoachesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainingsAndCoachesMutation, UpdateTrainingsAndCoachesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainingsAndCoachesMutation, UpdateTrainingsAndCoachesMutationVariables>(UpdateTrainingsAndCoachesDocument, options);
      }
export type UpdateTrainingsAndCoachesMutationHookResult = ReturnType<typeof useUpdateTrainingsAndCoachesMutation>;
export type UpdateTrainingsAndCoachesMutationResult = Apollo.MutationResult<UpdateTrainingsAndCoachesMutation>;
export type UpdateTrainingsAndCoachesMutationOptions = Apollo.BaseMutationOptions<UpdateTrainingsAndCoachesMutation, UpdateTrainingsAndCoachesMutationVariables>;